import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../ui";
import { PersonalChat } from "./PersonalChat";
import { GroupChat } from "./GroupChat";
import { useGetPresenceQuery } from "../../services/rtkApi/agentApi";
import "./agent_chat.css";

export default function AgentChatPage() {
  const { data: presence } = useGetPresenceQuery(undefined, {
    pollingInterval: 60_000,
  });

  const onlineCount = presence?.count || 0;

  // optional ?tab=personal|group deep-link (e.g. from a chat toast click); defaults to group.
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") === "personal" ? "personal" : "group";

  return (
    <div className="agent-chat-page">
      <div className="agent-chat-container">
        <Tabs defaultValue={initialTab} className="flex flex-col h-full">
          <div className="px-3 pt-3">
            <TabsList className="w-full">
              <TabsTrigger value="group" className="flex-1 gap-1.5">
                general
                {onlineCount > 0 && (
                  <span className="inline-flex items-center justify-center h-4 min-w-[16px] px-1 rounded-full bg-accent/40 text-[10px] font-bold">
                    {onlineCount}
                  </span>
                )}
              </TabsTrigger>
              <TabsTrigger value="personal" className="flex-1">
                personal
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="group" className="flex-1 overflow-hidden mt-0">
            <GroupChat />
          </TabsContent>

          <TabsContent value="personal" className="flex-1 overflow-hidden mt-0">
            <PersonalChat />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
